import themeConfig from '@config/theme.config';

const focusRing = {
  outline: `2px solid ${themeConfig.primaryColor}`,
  outlineOffset: 2,
};

const components = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        margin: 0,
        minHeight: '100vh',
        backgroundColor: themeConfig.pageBackground,
        color: themeConfig.textPrimary,
      },
      '#root': {
        minHeight: '100vh',
      },
      a: {
        color: 'inherit',
        textDecoration: 'none',
      },
      '*:focus-visible': focusRing,
    },
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: false,
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        borderRadius: themeConfig.borderRadius,
        textTransform: 'none',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        transition: 'background-color 160ms ease, box-shadow 160ms ease, border-color 160ms ease',
      },
      sizeMedium: {
        minHeight: 40,
        px: 2,
      },
      sizeLarge: {
        minHeight: themeConfig.fieldHeight,
        px: 2.5,
      },
      containedPrimary: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: themeConfig.shadowSm,
        },
      },
      outlined: {
        borderColor: themeConfig.borderColor,
        '&:hover': {
          borderColor: themeConfig.borderInput,
          bgcolor: themeConfig.surfaceSecondary,
        },
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        transition: 'background-color 160ms ease',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
      rounded: {
        borderRadius: themeConfig.borderRadiusLg,
      },
      outlined: {
        borderColor: themeConfig.borderColor,
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: themeConfig.borderRadiusLg,
        border: `1px solid ${themeConfig.borderColor}`,
        boxShadow: themeConfig.shadowSm,
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: themeConfig.borderRadiusLg,
        border: `1px solid ${themeConfig.borderColor}`,
        boxShadow: themeConfig.shadowMd,
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        fontSize: '1.125rem',
        fontWeight: 600,
        letterSpacing: '-0.02em',
        px: 3,
        pt: 3,
        pb: 1.5,
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        px: 3,
        py: 2,
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        px: 3,
        pb: 3,
        pt: 1.5,
        gap: 1,
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        '& .MuiTableCell-head': {
          bgcolor: themeConfig.surfaceSecondary,
          color: themeConfig.textSecondary,
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          borderBottomColor: themeConfig.borderColor,
          py: 1.5,
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderBottomColor: themeConfig.borderLight,
        py: 1.75,
        fontSize: 14,
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        transition: 'background-color 120ms ease',
        '&:hover': {
          bgcolor: themeConfig.surfaceSecondary,
        },
      },
    },
  },
  MuiTooltip: {
    defaultProps: {
      arrow: true,
    },
    styleOverrides: {
      tooltip: {
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 500,
        bgcolor: themeConfig.textPrimary,
      },
    },
  },
  MuiSkeleton: {
    styleOverrides: {
      root: {
        bgcolor: themeConfig.borderColor,
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRightColor: themeConfig.borderColor,
        backgroundImage: 'none',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        boxShadow: 'none',
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        transition: 'background-color 140ms ease, color 140ms ease',
      },
    },
  },
};

export default components;
